import * as z from 'zod';

import { zodJSPlainDate } from '../dates/BrandedDate';

export const ExpectedPayment = z.object({
  paymentDate: zodJSPlainDate,
  totalAmountRemainingFromBorrower: z.number(),
  totalAmountRemainingFromCredit: z.number(),
});

export type ExpectedPayment = z.infer<typeof ExpectedPayment>;
